import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Button from "../../atoms/Button";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import useModal from "../../../hooks/useModal";
import { toast } from "react-toastify";
import { GET_DEBIT_REGISTER, GET_ENTERPRISE_BY_ID } from "../../../api/apiEmpresas";
import { useSession } from "../../../context/SessionContext";
import CardTables from "../../atoms/CardTables";
import TableEstadoDeCuenta from "../../organisms/clientes/empresas/estadoDeCuenta/TableEstadoDeCuenta";
import Modal from "../../molecules/Modal";
import ModalCreateEstadoDeCuenta from "../../organisms/clientes/empresas/estadoDeCuenta/ModalCreateEstadoDeCuenta";
import CardHeader from "../../atoms/CardHeader";
import Breadcrumb from "../../molecules/Breadcrumb";

const EstadoDeCuentaTemplate = () => {
    const { id } = useParams();
    const { open, close, isOpen } = useModal();
    const [empresa, setEmpresa] = useState();
    const [debit, setDebit] = useState();
    const [loading, setLoading] = useState(false);
    const [totalCuenta, setTotalCuenta] = useState(0);
    const { user } = useSession();

    const getDebitRegister = useCallback (async () => {
        try {
            setLoading(true);
            const debitData = await GET_DEBIT_REGISTER(id);
            const sortedData = [...debitData].sort((a, b) => b.id - a.id);
            setDebit(sortedData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [id]);

    const getEnterprise = useCallback (async () => {
        try {
            setLoading(true);
            const enterpriseData = await GET_ENTERPRISE_BY_ID(id);
            setTotalCuenta(enterpriseData?.balance);
            setEmpresa(enterpriseData);
        } catch (error) {
            console.error(error);
            toast.error("Error al cargar los documentos");
        } finally {
            setLoading(false);
        }
    }, [id]);

    const handleRefetch = () => {
        getEnterprise();
        getDebitRegister();
    };

    useEffect(() => {
        getEnterprise();
        getDebitRegister();
    }, [getEnterprise, getDebitRegister]);

    return (
        <div className="w-full h-full flex flex-col space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: `${empresa?.name || "cargando..."}`, to: `/clientes/empresas/${empresa?.id}/decide` },
                        { label: "CONTABILIDAD", to: `/clientes/empresas/${empresa?.id}/` },
                        { label: "ESTADO DE CUENTA SERVICIO RS", to: null },
                    ]}
                />
                {user?.role !== "Client" &&
                    <Button text={<LiaMoneyCheckAltSolid size={22} />} bgColor="green" onClick={open} width="w-10" />
                }
            </CardHeader>
            <CardTables>
                <TableEstadoDeCuenta data={debit} refetch={handleRefetch} loading={loading} cuenta={totalCuenta} />
            </CardTables>
            {isOpen &&
                <Modal title="Agregar pago" onClose={close} >
                    <ModalCreateEstadoDeCuenta refetch={handleRefetch} id={id} onClose={close} cuenta={totalCuenta}/>
                </Modal>
            }
        </div>
    );
};

export default EstadoDeCuentaTemplate;